module.exports = __webpack_public_path__ + "static/media/no-found-notes.7b5f28ce.svg";